module.exports = __webpack_public_path__ + "static/media/enter-orange.4949c4bd.svg";